export class Config {
  static serverUrl = 'https://app-ws.overit.it';
  static MSAL_REDIRECT_URI = 'https://app-admin.overit.it';
}
